export default __webpack_public_path__ + "locales/az/SalesDepartmentRequestDialog.json?hash=782fef5f00699b7af631dc3c504cda0a";